import {SET_CURRENT_PAYOUT_REQUEST} from '../action_types'

export default (payoutRequest, payoutRequestId) => {
  return {type: SET_CURRENT_PAYOUT_REQUEST, payoutRequest, payoutRequestId}
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/actions/set_current_payout_request.js
 **/